<template>
  <div class="text-dark">
    <ChooseSalarySystem
      v-if="isAllLoaded && !salarySystem"
      :schoolId="schoolId"
    ></ChooseSalarySystem>

    <div class="d-sub-header">
      <p
        v-for="item in menu"
        :key="item.key"
        class="d-sub-header__link"
        :class="{'d-sub-header__link--active': activePage === item.key}"
        @click="setActivePage(item.key)"
      >
        {{ item.label }}
      </p>
    </div>

    <template v-if="isAllLoaded && activeTab">
      <component
        :is="activeTab.component"
        v-bind="getPropsFor(activeTab.key)"
        @select="onTemplateSelected"
        @onTemplateCreated="onTemplateCreated"
        @onTemplateUpdated="onTemplateUpdated"
        @onTemplateDeleted="onTemplateDeleted"
      ></component>
    </template>
  </div>
</template>

<script>
import EmploymentTemplatesTable from './SchoolSettings/EmploymentTemplates.vue'
import Loader from '../common/Loader.vue'
import ChooseSalarySystem from '../Supplements/ChooseSalarySystem.vue'
import Tjenestenumre from './Silkeborgdata/Tjenestenumre.vue'
import CostCenters from './SchoolSettings/CostCenters.vue'
import SalaryCodes from './SchoolSettings/SalaryCodes.vue'
import Loenbroek from './Silkeborgdata/Loenbroek.vue'
import OpusAbsence from './KMD/OpusAbsence.vue'
import Ansaettelsesnumre from './KMD/Ansaettelsesnumre.vue'
import Engangsydelser from './KMD/Engangsydelser.vue'
import FasteTillaeg from './KMD/FasteTillaeg.vue'
import SdEngangsydelser from './Silkeborgdata/SdEngangsydelser.vue'
import SdFasteTillaeg from './Silkeborgdata/SdFasteTillaeg.vue'
import SdFravaer from './Silkeborgdata/SdFravaer.vue'
export default {
  components: {
    CostCenters,
    Tjenestenumre,
    ChooseSalarySystem,
    SalaryCodes,
    EmploymentTemplatesTable,
    Loader,
    Loenbroek,
    OpusAbsence,
    Ansaettelsesnumre,
    Engangsydelser,
    FasteTillaeg,
    SdEngangsydelser,
    SdFasteTillaeg,
    SdFravaer
  },
  data () {
    return {
      activePage: 'fravaer',
      loadedSchoolId: null
    }
  },
  computed: {
    routeSchoolId () {
      const param = this.$route && this.$route.params ? this.$route.params.school_id : null
      return param ? parseInt(param, 10) : null
    },
    menu () {
      if (this.salarySystem === 'SD') {
        return [
          {key: 'fravaer', label: 'Fraværsindberetninger', component: 'SdFravaer'},
          {key: 'ydelse', label: 'Engangsydelser', component: 'SdEngangsydelser'},
          {key: 'tillaeg', label: 'Faste tillæg', component: 'SdFasteTillaeg'},
          // {key: 'loenbroeker', label: 'Lønbrøker', component: 'Loenbroek'},
          {key: 'tjenestenumre', label: 'Ansættelser', component: 'Tjenestenumre'},
          {key: 'stillingskategorier', label: 'Stillingskategorier', component: 'EmploymentTemplatesTable'},
          {key: 'lønkoder', label: 'Lønkoder', component: 'SalaryCodes'},
          {key: 'costcenters', label: 'Omkostningssteder', component: 'CostCenters'}
        ]
      } else {
        return [
          {key: 'fravaer', label: 'Fraværsindberetninger', component: 'OpusAbsence'},
          {key: 'engangsydelser', label: 'Engangsydelser', component: 'Engangsydelser'},
          {key: 'faste-tillaeg', label: 'Faste tillæg', component: 'FasteTillaeg'},
          {key: 'ansættelsesnumre', label: 'Ansættelser', component: 'Ansaettelsesnumre'},
          {key: 'stillingskategorier', label: 'Stillingskategorier', component: 'EmploymentTemplatesTable'},
          {key: 'lønkoder', label: 'Lønkoder', component: 'SalaryCodes'},
          {key: 'costcenters', label: 'Omkostningssteder', component: 'CostCenters'}
        ]
      }
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    salarySystem () {
      return this.$store.getters.salarySystem
    },
    isSDIntegrationActive () {
      return this.activeSchool && this.activeSchool.features && this.activeSchool.features.includes('silkeborg_data_integration')
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    schoolYearId () {
      return this.$store.getters.schoolYearId
    },
    isAllLoaded () {
      return this.schoolId && this.schoolYearId && this.schoolYear
    },
    // Hvis du allerede har valgte medarbejdere et andet sted i store, kan du mappe dem her.
    // Ellers bliver det bare en tom liste, som komponenten håndterer fint.
    selectedEmploymentIds () {
      if (this.$store && this.$store.getters && this.$store.getters.selectedEmploymentIds) {
        return this.$store.getters.selectedEmploymentIds
      }
      return []
    },
    activeTab () {
      const match = this.menu.filter(m => m.key === this.activePage)
      return match.length > 0 ? match[0] : null
    }
  },
  methods: {
    ensureActiveSchoolFromRoute () {
      const id = this.routeSchoolId
      if (!id) return
      if (this.activeSchool && this.activeSchool.id === id) return
      this.$store.dispatch('readActiveSchool', {id: id})
    },
    loadSalaryData () {
      if (!this.schoolId || this.loadedSchoolId === this.schoolId) return
      this.loadedSchoolId = this.schoolId
      this.$store.dispatch('readSalaryCodes')
      this.$store.dispatch('readCostCenters')
    },
    setActivePage (page) {
      this.activePage = page
    },
    getPropsFor (key) {
      if (key === 'lønkoder') {
        return {}
      }
      if (key === 'stillingskategorier') {
        return {
          selectedEmploymentIds: this.selectedEmploymentIds
        }
      }
      return {
        theType: key
      }
    },

    // Event handlers fra EmploymentTemplatesTable (kan tilpasses)
    onTemplateSelected (tpl) {
      // Propager evt. videre op hvis parent skal gøre noget
      this.$emit('template-selected', tpl)
    },
    onTemplateCreated () {
      this.$emit('template-created')
    },
    onTemplateUpdated () {
      this.$emit('template-updated')
    },
    onTemplateDeleted () {
      this.$emit('template-deleted')
    }
  },
  watch: {
    routeSchoolId () {
      this.ensureActiveSchoolFromRoute()
    },
    schoolId (val) {
      if (val) this.loadSalaryData()
    }
  },
  created () {
    this.ensureActiveSchoolFromRoute()
  },
  mounted () {
    this.loadSalaryData()
  }
}
</script>

<style scoped>
.do-margin-grid {
  margin: -1rem;
}

.d-sub-header {
  height: 40px;
  border-bottom: solid 1px #CCCCCC;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 10px;
}

.d-sub-header__link {
  font-weight: bold;
  margin: 0 20px;
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #3e4450;
  opacity: 0.7;
  text-transform: uppercase;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  cursor: pointer;
}

.d-sub-header__link--active {
  opacity: 1;
  border-bottom: 2px solid #468AD7;
  transition: all 0.15s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// Salary.vue?2b60d0a8